import { execOnLoad, formatPrice } from '@general/helpers';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import { initProductForm } from '@components/product';
import { openMinicart } from '@components/minicart';
import breakpoints from 'breakpoints';
import { throttle } from 'lodash';
import {
  addToWishlist,
  getWishlist,
  deleteFromWishlist,
} from '@components/wishlist';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTile = (context) => {
  const snippetContainer = context.classList.contains(
    '.product-tile__container',
  )
    ? context
    : context.closest('.product-tile__container');
  if (
    !snippetContainer ||
    snippetContainer.classList.contains('product-tile__container--initialized')
  )
    return;

  const swiperWrapper = snippetContainer.querySelector(
    '.product-tile__gallery .swiper-wrapper',
  );
  if (
    swiperWrapper &&
    swiperWrapper.querySelectorAll('.swiper-slide').length > 1
  ) {
    const swiperContainer = swiperWrapper.closest('.product-tile__gallery');
    const pagination = swiperContainer.querySelector(
      '.product-tile__gallery-pagination',
    );
    const options = {
      modules: [Navigation, ...(pagination ? [Pagination] : [])],
      navigation: {
        prevEl: swiperContainer.querySelector(
          '.product-tile__gallery-arrow--left',
        ),
        nextEl: swiperContainer.querySelector(
          '.product-tile__gallery-arrow--right',
        ),
      },
      ...(pagination
        ? {
            pagination: {
              el: pagination,
            },
          }
        : {}),
    };
    var changeSlide = true;
    const swiper = new Swiper(swiperContainer, options);
    swiperContainer.addEventListener('mouseenter', () => {
      if (window.innerWidth <= parseInt(breakpoints.lg)) return;
      if (changeSlide) swiper.slideNext();
      changeSlide = false;
    });
  }

  const quickBuy = snippetContainer.querySelector('.product-tile__quick-buy');
  const form = snippetContainer.querySelector('.product-tile__form');
  const wishlistButton = snippetContainer.querySelector('[data-wishlist-btn]');
  if (quickBuy && form)
    initProductForm({
      form,
      callbacks: {
        afterVariantChange: async ({ variant, product }) => {
          if (wishlistButton) {
            wishlistButton.dataset.wishlistVariantId = variant?.id;
            wishlistButton.dataset.wishlistPrice = formatPrice({
              value: variant?.price ?? 0,
            });
            wishlistButton.dataset.wishlistCompareAtPrice =
              variant?.compare_at_price
                ? formatPrice({
                    value: variant?.compare_at_price,
                  })
                : '';

            const wishlist = await getWishlist();
            const wishlistProduct = wishlist?.listcontents?.find(
              (addedProduct) =>
                addedProduct.epi == variant.id &&
                addedProduct.empi == product.id,
            );
            wishlistButton.dataset.wishlistStatus = wishlistProduct
              ? 'active'
              : 'inactive';
          }
        },
        afterSubmit: () => openMinicart(true),
      },
    });

  snippetContainer.classList.add('product-tile__container--initialized');

  if (wishlistButton) {
    const toggleLoading = throttle(() => {
      wishlistButton.classList.toggle('loading');
    }, 500);
    wishlistButton.addEventListener('click', async (e) => {
      e.preventDefault();
      toggleLoading();
      const variantID = wishlistButton?.dataset?.wishlistVariantId;
      const masterID = wishlistButton?.dataset?.wishlistProductId;
      const productURL = wishlistButton?.dataset?.wishlistProductUrl;
      const price = wishlistButton?.dataset?.wishlistPrice;
      const compareAtPrice = wishlistButton?.dataset?.wishlistCompareAtPrice;

      if (wishlistButton?.dataset?.wishlistStatus === 'active') {
        await deleteFromWishlist({ variantID, masterID, productURL });
        wishlistButton.dataset.wishlistStatus = 'inactive';
      } else {
        await addToWishlist({
          variantID,
          masterID,
          productURL,
          compareAtPrice,
          price,
        });
        wishlistButton.dataset.wishlistStatus = 'active';
      }
      toggleLoading();
    });
  }
};

execOnLoad(window.dAgency.initProductTile, '.product-tile__container');
